<div class="row pb-2 m-0" *ngIf="data">
  <div
    class="col-sm-4 col-12 order-xxl-1 order-xs-1 order-xl-1 order-lg-1 order-md-1 order-sm-1 order-1 d-flex justify-content-sm-start align-items-sm-start justify-content-center align-items-center flex-wrap align-content-start p-0"
  >
    <h5 class="m-0 mobile-size">
      {{ data.title | translate }}
    </h5>
  </div>
  <div
    class="col-sm-4 col-12 order-xxl-2 order-xs-2 order-xl-2 order-lg-2 order-md-2 order-sm-2 order-3 d-flex justify-content-center align-items-center p-0"
  >
    <div
      class="search-box d-flex justify-content-end align-items-center p-0"
      [ngClass]="{'is-invalid': searchColumnMessage!=null||searchValueMessage!=null }"
      *ngIf="header"
    >
      <button
        type="button"
        class="btn btn-icon"
        *ngIf="searchValue && searchValue.length > 0"
        (click)="clearSearch()"
      >
        <i class="far fa-times-circle"></i>
      </button>
      <p class="value-error">{{ searchColumnMessage }}</p>
      <input
        type="text"
        class="form-control px-1"
        [(ngModel)]="searchValue"
        (keyup.Enter)="letsSearch()"
      />
      <p class="key-error">{{ searchValueMessage }}</p>
      <select
        class="form-select p-1"
        [(ngModel)]="searchColumn"
        *ngIf="searchField"
      >
        <option selected value="">{{ "Choose" | translate }}</option>
        <option *ngFor="let column of searchField" [value]="column.fieldName">
          {{ column.label | translate }}
        </option>
      </select>
    </div>
  </div>
  <div
    class="col-sm-4 col-12 col-sm-4 col-12 order-xxl-3 order-xs-3 order-xl-3 order-lg-3 order-md-3 order-sm-3 order-2 d-flex justify-content-end mb-2 p-0"
  >
    <button
      type="button"
      class="btn btn-icon ms-1"
      placement="bottom"
      *ngFor="let button of data.buttons"
      [ngClass]="button.className"
      ngbTooltip="{{ button.name | translate }}"
      (click)="callParent(button.name, null)"
    >
      <span class="tf-icons" [ngClass]="button.icon"></span>
    </button>
  </div>
</div>
